// 共有の頂点シェーダ。単位クアッド (0..1) を uRect (x, y, w, h) の矩形へ置き、
// uToClip (mat3) でクリップ座標へ変換する。vPos は矩形内の座標 (uRect 空間)。

export const RECT_VERT = /* glsl */ `#version 300 es
layout(location = 0) in vec2 aUnit;
uniform vec4 uRect;      // 描画先矩形 (描画空間)
uniform mat3 uToClip;    // 描画空間 → クリップ空間
out vec2 vPos;           // 描画空間の座標
void main() {
  vPos = uRect.xy + aUnit * uRect.zw;
  vec3 c = uToClip * vec3(vPos, 1.0);
  gl_Position = vec4(c.xy, 0.0, 1.0);
}
`

/** 文書空間 (0..w, 0..h) → クリップ空間 (-1..1)。y は反転しない (テクスチャ行 = 文書行) */
export function docToClipMatrix(w: number, h: number): Float32Array {
  return new Float32Array([2 / w, 0, 0, 0, 2 / h, 0, -1, -1, 1])
}
